module.exports = __webpack_public_path__ + "static/media/chilli.15c6b1a9.png";